import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    position: 'relative',
    paddingBottom: 20,
    '&:last-child': {
      paddingBottom: 0,
    },
    '&:last-child $line': {
      display: 'none',
    },
  },
  dotContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: 16,
    minWidth: 24,
  },
  dot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    border: '2px solid',
    backgroundColor: '#fff',
    zIndex: 1,
  },
  line: {
    width: 2,
    flex: 1,
    backgroundColor: '#e0e0e0',
    marginTop: 4,
  },
  content: {
    flex: 1,
    paddingTop: 0,
  },
  timestamp: {
    fontSize: '0.75rem',
    color: '#999',
    marginBottom: 2,
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  description: {
    fontSize: '0.8rem',
    color: '#666',
    marginTop: 2,
  },
  user: {
    fontSize: '0.75rem',
    color: '#888',
    fontStyle: 'italic',
    marginTop: 2,
  },
}));

/**
 * Timeline event component for SurgeryTimeline and SurgeryAuditLog.
 * Shows a dot-and-line vertical timeline with event details.
 */
const TimelineEvent = ({
  timestamp,
  title,
  description,
  user,
  color = '#3F51B5',
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.dotContainer}>
        <div className={classes.dot} style={{ borderColor: color }} />
        <div className={classes.line} />
      </div>
      <div className={classes.content}>
        {timestamp && (
          <Typography className={classes.timestamp}>{timestamp}</Typography>
        )}
        <Typography className={classes.title}>{title}</Typography>
        {description && (
          <Typography className={classes.description}>{description}</Typography>
        )}
        {user && (
          <Typography className={classes.user}>by {user}</Typography>
        )}
      </div>
    </div>
  );
};

export default TimelineEvent;
